import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import NeuralCanvas from '../NeuralCanvas';
import './SubmissionSuccess.css';

const SubmissionSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  // Asegurar que el body permita scroll en esta vista
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = prevOverflow || '';
    };
  }, []);

  return (
    <>
      {/* Fondo animado en fixed, sin capturar eventos para no bloquear el scroll */}
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1, pointerEvents: 'none' }}>
        <NeuralCanvas />
      </div>

      <div className="success-container">
        <div className="success-content">
          <h1>{t('form.success.title')}</h1>

          <div className="success-message">
            <p className="email-sent">
              {t('form.success.emailSent')} <strong>{email}</strong>
            </p>
            <p>{t('form.success.checkInbox')}</p>
            <p className="check-spam">{t('form.success.checkSpam')}</p>
          </div>

          <div className="next-steps">
            <h2>{t('form.success.nextSteps.title')}</h2>
            <ul>
              <li>{t('form.success.nextSteps.step1')}</li>
              <li>{t('form.success.nextSteps.step2')}</li>
              <li>{t('form.success.nextSteps.step3')}</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubmissionSuccess; 